import * as React from 'react';
export const uspsSvg = React.forwardRef(function uspsSvgInner(props, ref) {
  return /*#__PURE__*/ React.createElement(
    'svg',
    {
      ...props,
      ref: ref,
    },
    /*#__PURE__*/ React.createElement('path', {
      fill: '#F5F6F8',
      d: 'M0 0h32v32H0z',
    }),
    /*#__PURE__*/ React.createElement('path', {
      d: 'm7.963 8 12.907 2.836c2.07.456 2.333 1.164 2.333 1.164s2.264-.274 2.68.514c.532 1.01-.83 2.927-.83 2.927L5.483 23.12h20.323L29.14 8H7.963Z',
      fill: '#124888',
    }),
    /*#__PURE__*/ React.createElement('path', {
      d: 'M19.241 11.51c-1.767-.23-11.308-.148-12.71-.134L4 23.12a569.99 569.99 0 0 1 11.162-5.464c4.878-2.328 8.235-2.924 8.93-2.958.47-.023.204-.227-.019-.276-2.725-.601-9.334 2.464-9.334 2.464l-1.444-4.382 9.409.01c-.437-.647-1.239-.741-2.617-.903-.261-.03-.543-.063-.846-.103Z',
      fill: '#124888',
    }),
    /*#__PURE__*/ React.createElement('path', {
      d: 'M20.68 13.242c2.012-.168 2.109-.713 2.109-.713s1.655-.048 2.122.055c.467.103.57.4.552.688-.017.287-.62 1.5-.72 1.6-.099.101-.222.105-.157-.05.064-.153.316-.81.365-1.028.048-.219.097-.445-.277-.482-.241-.024-1.721.016-2.81.045-.6.016-1.082.03-1.169.026-.243-.007-.199-.125-.015-.14Z',
      fill: '#124888',
    }),
  );
});
uspsSvg.defaultProps = {
  width: '32',
  height: '32',
  viewBox: '0 0 32 32',
  fill: 'none',
  xmlns: 'http://www.w3.org/2000/svg',
};
export var usps = {
  category: 'brand',
  colorable: false,
  name: 'usps',
  svg: uspsSvg,
};
